import type { ShiftMealRecord } from '@libs/data-access/queries'
import type { FC } from 'react'

import MealNotTaken from './MealNotTaken'
import MealTaken from './MealTaken'

type ScheduleType = 'planned' | 'real' | 'clocked'

type MealRowProps = {
  meal: ShiftMealRecord
  scheduleType: ScheduleType
}

/**
 * @deprecated
 */
const MealRowLegacy: FC<MealRowProps> = ({ meal, scheduleType }) => {
  if (scheduleType === 'clocked') {
    const clockedMealTakenStatus = meal.get('clocked_meal_taken_status')

    if (clockedMealTakenStatus === 'taken') {
      return <MealTaken mealType={meal.get('planned_meal_type')} />
    }

    if (clockedMealTakenStatus === 'not_taken') {
      return <MealNotTaken />
    }

    // If clockedMealTakenStatus is not given, it means that we don't have the information about the meal, so we don't
    //  display anything. It happens notably if the option "Autoriser les employés à renseigner leur(s) repas" is disabled
    return null
  }

  if (scheduleType === 'real') {
    const realMealType = meal.get('real_meal_type')
    if (realMealType) {
      return <MealTaken mealType={realMealType} />
    }
    return <MealNotTaken />
  }

  // scheduledType is 'planned'
  const plannedMealType = meal.get('planned_meal_type')
  return plannedMealType ? <MealTaken mealType={plannedMealType} /> : null
}

export { ScheduleType }
export default MealRowLegacy
